import { useEffect, useState } from "react";
//import { Redirect } from "react-router-dom";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import MaskedInput from "react-maskedinput";
import Card from "../../../components/Card";
import Footer from "../../../components/Footer";
import HeaderInterno from "../../../components/HeaderInterno";
import Modal from "../../../components/Modal";
import schema from "./schema";

import { connect } from "react-redux";
import { exibeModal } from "../../../actions/ModalActions";

import {
  editId,
  editIdPlanoGetnet,
  editValor,
} from "../../../actions/PlanosEscolhidoActions";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LoadingGif } from "../../../components/LoadingGif";

const Pagamento = ({
  idCliente,
  exibeModal,
  dadosPlanoEscolhido,
  editValor,
  editId,
  editIdPlanoGetnet,
}) => {
  const [exibeLoading, setExibeLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [titulo, setTitulo] = useState("");
  const [mostraModal, setMostraModal] = useState(false);
  const [btnPagamentoDesabilitado, setBtnPagamentoDesabilitado] =
    useState(false);
  const [meiosPagamento, setMeiosPagamento] = useState([]);
  const [dadosCupomDesconto, setDadosCupomDesconto] = useState({});
  const [cupomValido, setCupomValido] = useState(null);
  const [idMeioPagamento, setIdMeioPagamento] = useState(0);
  const [idPedido, setIdPedido] = useState(0);
  const [cupomDesconto, setCupomDesconto] = useState("");
  /*const [dadosPedido, setDadosPedido] = useState({
    idPedido: 0,
    cliente_id: 0,
    vendedor_id: 0,
    descricao_composicao_id: 0,
    meio_pagamento_id: 0,
    valor_venda: "",
    status: "",
    resposta: "",
  });*/

  const history = useHistory(); // Obtém o objeto history

  //Função para buscar os meios de pagamento
  const getMeiosPagamento = async () => {
    try {
      const meiosPagamento = await axios.get(
        process.env.REACT_APP_API_URL + "meio-de-pagamento/listar",
      );

      if (meiosPagamento.status === 200) {
        setMeiosPagamento(meiosPagamento.data);
      }
    } catch (error) {
      console.log("Erro ao buscar meios de pagamento:", error);
    }
  };

  useEffect(() => {
    // Chama a função para buscar os meios de pagamento ao montar o componente
    getMeiosPagamento();
  }, []);

  const modal = (titulo, bgcolor, msg) => {
    return (
      <Modal
        isOpen={true}
        title={titulo}
        classCssHeader={`${bgcolor} color-white`}
        close={() => bgcolor === "bg-success" && history.push("/")}
      >
        <p>{msg}</p>
      </Modal>
    );
  };

  //FUNÇÂO QUE PROCESSA O PAGAMENTO (server-to-server com a Getnet, via Salud_Backend)
  const efetuarPagamento = async (idPedido, dados) => {
    try {
      const pagamento = await axios.post(
        process.env.REACT_APP_API_URL + "pagamento/efetuar",
        {
          pedido: { id: idPedido },
          numero_cartao: dados.numeroCartao,
          nome_cartao: dados.nomeCartao,
          validade_cartao: dados.validadeCartao,
          codigo_seguranca: dados.codigoCartao,
        },
      );

      return pagamento;
    } catch (error) {
      return {
        data: {
          msg: `Error na requisição de pagamento ${error}`,
          status: "erro",
          dados: [],
        },
      };
    }
  };

  //FUNÇÂO QUE ENVIA EMAIL DE CADASTRO DA ASSINATURA
  const enviarEmail = async (nome, email, tipo_venda) => {
    try {
      const enviar = await axios.post(
        process.env.REACT_APP_API_URL + "venda/enviaEmailPosVenda",
        {
          nome: nome,
          email: email,
          tipo_venda: tipo_venda,
        },
      );

      return enviar;
    } catch (error) {
      return {
        data: {
          msg: `Error na requisição enviarEmail ${error}`,
          status: "erro",
          dados: [],
        },
      };
    }
  };

  //FUNÇÂO QUE GERA O DESCONTO DO CUPOM
  const geraDesconto = async (cupom) => {
    if (cupom) {
      try {
        const { qtdeDependentes } = dadosPlanoEscolhido;

        const desconto = await axios.get(
          process.env.REACT_APP_API_URL +
            `cupom/buscarPorNomeEQtdeDependentes?nome-cupom=${cupom}&qtde-dependentes=${qtdeDependentes}`,
        );

        if (desconto.data.status === "sucesso") {
          //salvando os dados do plano de desconto no Estado
          setDadosCupomDesconto(desconto.data.dados);
          setCupomValido(true);

          const { id, valor_total, id_plano_getnet } = desconto.data.dados;

          //Atualizando o plano escolhido com os dados do cupom no redux
          editId(id);
          editValor(valor_total);
          editIdPlanoGetnet(id_plano_getnet);
        } else {
          console.log("Cupom inválido ou não encontrado.");
          setCupomValido(false);
        }
      } catch (error) {
        console.error("Erro ao gerar desconto:", error);
      }
    }
  };

  //INSERTE TABELA DE PEDIDOS
  const insertPedido = async (dados) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "pedido/cadastrar",
        dados,
      );

      return response;
    } catch (error) {
      return false;
    }
  };

  //INSERTE TABELA DE VENDAS
  const insertVenda = async (dadosVenda) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "venda/cadastrar",
        dadosVenda,
      );

      return response;
    } catch (error) {
      return false;
    }
  };

  //UPDATE TABELA DE PEDIDOS
  const updatePedido = async (dados, idPedido) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}pedido/atualizar/${idPedido}`,
        dados,
      );

      return response;
    } catch (error) {
      console.error("Erro ao atualizar pedido:", error);
    }
  };

  //FUNÇÂO QUE REALIZA O SUBMIT DO FORMULÁRIO
  const submit = async (values, { resetForm }) => {
    setExibeLoading(true);
    setBtnPagamentoDesabilitado(true);

    try {
      let dadosPedido = {
        cliente_id: idCliente,
        vendedor_id: dadosCupomDesconto.vendedor_id || null,
        descricao_composicao_id: dadosPlanoEscolhido.id,
        meio_pagamento_id: idMeioPagamento,
        valor_venda: dadosPlanoEscolhido.valor,
        status: "",
        resposta: "",
      };

      //Inserindo o pedido no banco de dados
      const inserirPedidos = await insertPedido(dadosPedido);

      if (!inserirPedidos || inserirPedidos.data.status === "erro") {
        console.log("Erro ao inserir pedido:", inserirPedidos.data.msg);
      }

      dadosPedido.idPedido = inserirPedidos.data.dados.id;

      //processando o pagamento (server-to-server com a Getnet, via Salud_Backend)
      const pagamento = await efetuarPagamento(dadosPedido.idPedido, values);

      let nomeCliente = "";
      let emailCliente = "";

      if (pagamento.data.status === "erro") {
        setTitulo("Erro");
        setBgColor("bg-danger");
        setMsg("Erro ao realizar a assinatura. " + pagamento.data.msg);
        dadosPedido = {
          ...dadosPedido,
          status: "erro",
          resposta: pagamento.data.msg,
        };

        setMostraModal(true);
        exibeModal(true);
      } else {
        setTitulo("Sucesso");
        setBgColor("bg-success");
        setMsg(
          "Assinatura realizada com sucesso! Você receberá um e-mail de confirmação.",
        );
        dadosPedido = {
          ...dadosPedido,
          status: "sucesso",
          resposta: "Assinatura realizada com sucesso!",
        };

        nomeCliente = pagamento.data.dados.cliente?.first_name || "";
        emailCliente = pagamento.data.dados.cliente?.email || "";

        //INSERT NA TABELA DE VENDAS
        const dadosInsertVenda = await insertVenda({
          pedido_id: dadosPedido.idPedido,
        });

        if (dadosInsertVenda.data.status === "sucesso") {
          console.log("Venda inserida com sucesso!");
        } else {
          console.log("Erro ao inserir venda:", dadosInsertVenda.data.msg);
        }

        setMostraModal(true);
        exibeModal(true);

        //Limpar o formulário
        resetForm();
      }

      //Atualizar os dados do pedido
      const updateDadosPedido = await updatePedido(
        dadosPedido,
        dadosPedido.idPedido,
      );

      if (updateDadosPedido.data.status === "erro") {
        console.log(
          "Erro ao atualizar dados do pedido:",
          updateDadosPedido.data.msg,
        );
      }

      //Realizar o envio do email (só faz sentido se o pagamento foi aprovado)
      if (dadosPedido.status === "sucesso") {
        const tipo_venda =
          dadosPlanoEscolhido.titulo === "Titular"
            ? "somente_titular"
            : "titular_e_dependentes";

        const enviar = await enviarEmail(nomeCliente, emailCliente, tipo_venda);

        if (enviar.data.status === "erro") {
          console.log("Erro ao enviar email:", enviar.data.mensagem);
        }
      }
    } catch (error) {
      console.log("Erro ao cadastrar assinatura:", error);
    } finally {
      setExibeLoading(false);
      setBtnPagamentoDesabilitado(false);
    }
  };

  /*if (redirect) {
    return <Redirect to="/transacao" />;
  }*/

  return (
    <>
      <HeaderInterno tituloHeader="Formas de pagamento" />
      <div className="container">
        {exibeLoading && <LoadingGif />}
        <section className="container-form">
          {mostraModal === true ? modal(titulo, bgColor, msg) : ""}

          {/*CUPOM DE DESCONTO*/}
          <Card textoHeader="Cupom de desconto">
            <div className="row">
              <div className="col-xs-12 col-lg-6">
                <label>Insira o cupom de desconto: </label>{" "}
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    name="cupomDesconto"
                    onChange={(e) => setCupomDesconto(e.target.value)}
                    // value={cupomDesconto}
                  />
                  <button
                    className="btn btn-primary btn-sm btn-border-radius-0"
                    onClick={() => geraDesconto(cupomDesconto)}
                  >
                    Validar Cupom
                  </button>
                </div>
              </div>

              <div className="col-xs-12 col-lg-6" style={{ marginTop: "20px" }}>
                {cupomValido && (
                  <div className="alert alert-success" role="alert">
                    Cupom de desconto{" "}
                    <strong style={{ textTransform: "uppercase" }}>
                      {cupomDesconto}
                    </strong>{" "}
                    foi validado com sucesso.
                  </div>
                )}
                {cupomValido === false && (
                  <div className="alert alert-danger" role="alert">
                    Cupom de desconto{" "}
                    <strong style={{ textTransform: "uppercase" }}>
                      {cupomDesconto}
                    </strong>{" "}
                    não é válido.
                  </div>
                )}
              </div>
            </div>
          </Card>

          {/*DADOS DO PLANO ESCOLHIDO*/}
          <Card textoHeader="Dados do Plano Escolhido">
            <div className="row">
              <div className="col-xs-12 col-lg-6">
                <p>
                  <span className="span-plano-esclhido">Plano: </span>{" "}
                  {dadosPlanoEscolhido.titulo}
                </p>
              </div>
              <div className="col-xs-12 col-lg-6">
                <p>
                  <span className="span-plano-esclhido">Valor: </span> R$
                  {dadosPlanoEscolhido.valor}
                </p>
              </div>
            </div>
          </Card>

          {/*DADOS DO PAGAMENTO*/}
          <Card textoHeader="Dados do pagamento">
            <Formik
              onSubmit={submit}
              initialValues={{
                termosContrato: false,
                numeroCartao: "",
                nomeCartao: "",
                validadeCartao: "",
                codigoCartao: "",
                bandeiraCard: 0,
              }}
              validationSchema={schema}
              render={({ values, setFieldValue }) => (
                <Form className="clearfix">
                  <div className="row">
                    <div className="col-xs-12 col-lg-8">
                      <Field
                        type="checkbox"
                        name="termosContrato"
                        style={{ marginRight: "10px" }}
                      />
                      <label>
                        <a href="contrato-secuidae.pdf">
                          Li e aceito os termos do contrato
                        </a>
                      </label>
                      <span
                        className="error-message"
                        style={{ display: "block" }}
                      >
                        <ErrorMessage name="termosContrato" />
                      </span>
                    </div>
                  </div>
                  <hr />
                  {/**FAZER COMPONENTE PARA OS MEIOS DE PAGAMENTO*/}
                  <div className="row">
                    <div className="col-xs-12 col-lg-6">
                      <label>Bandeira do cartão</label>
                    </div>
                  </div>
                  <div className="row">
                    {meiosPagamento.map((meio) => (
                      <div className="col-xs-4 col-lg-2" key={meio.id}>
                        <input
                          name="bandeiraCard"
                          type="radio"
                          value={meio.id}
                          className="form-check-input input-plano"
                          onChange={() => setIdMeioPagamento(meio.id)}
                        />
                        <img
                          src={`${process.env.REACT_APP_PUBLIC_URL}imagens/${meio.meio.toLowerCase()}.png`}
                          alt={meio.meio}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="row">
                    <div className="col-xs-4 col-lg-2">
                      <span className="error-message">
                        <ErrorMessage name="bandeiraCard" />
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-lg-6">
                      <label>Número do cartão</label>
                      <MaskedInput
                        className="form-control"
                        name="numeroCartao"
                        mask="1111 1111 1111 1111"
                        value={values.numeroCartao}
                        onChange={(val) =>
                          setFieldValue("numeroCartao", val.target.value)
                        }
                      />
                      <span className="error-message">
                        <ErrorMessage name="numeroCartao" />
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-lg-6">
                      <label>Nome impresso no cartão</label>
                      <Field className="form-control" name="nomeCartao" />
                      <span className="error-message">
                        <ErrorMessage name="nomeCartao" />
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-lg-3">
                      <label>validade</label>
                      <MaskedInput
                        className="form-control"
                        name="validadeCartao"
                        mask="11/11"
                        value={values.validadeCartao}
                        onChange={(val) =>
                          setFieldValue("validadeCartao", val.target.value)
                        }
                      />
                      <span className="error-message">
                        <ErrorMessage name="validadeCartao" />
                      </span>
                    </div>
                    <div className="col-xs-12 col-lg-3">
                      <label>CVV</label>
                      <Field
                        className="form-control"
                        name="codigoCartao"
                        maxLength="3"
                      />
                      <span className="error-message">
                        <ErrorMessage name="codigoCartao" />
                      </span>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "30px" }}>
                    <div className="col-xs-12 col-lg-6">
                      <button
                        className="btn btn-primary"
                        style={{ float: "right" }}
                        type="submit"
                        disabled={btnPagamentoDesabilitado}
                      >
                        Enviar
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            />
          </Card>
        </section>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    idCliente: state.cliente.idCliente,
    dadosPlanoEscolhido: {
      id: state.plano.id,
      idPlanoGetnet: state.plano.idPlanoGetnet,
      titulo: state.plano.titulo,
      valor: state.plano.valor,
      qtdeDependentes: state.plano.qtdeDependentes,
    },
  };
};

const connetPagamento = connect(mapStateToProps, {
  exibeModal,
  editValor,
  editId,
  editIdPlanoGetnet,
})(Pagamento);

export default connetPagamento;
